import controller from './wf-form-actions.controller';
import template from './wf-form-actions.html';
import './wf-form-actions.scss';

export default {
	controller,
	controllerAs: '$ctrl',
	template,
	bindings:     {
		actionKid:    '<?',
		affect:       '=',
		affectKid:    '<',
		disabled:     '<?ngDisabled',
		kid:          '<',
		modelActions: '=',
		onCancel:     '&?',
		onClick:      '&?',
		onRedirect:   '&?',
		options:      '<?',
	},
};
